module.exports = __webpack_public_path__ + "static/media/cat.1485f50c.glb";